// extracted by mini-css-extract-plugin
export default {"container":"n4R9u","mobileContainer":"ey+Wz","divider":"dYlQ7"};